import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getQueryKey } from '~/services'
import { resolveKey } from '~/services/preferences/preferences'
import { setAccountPreference, SetAccountPreferencePropsUnion } from '~/services/preferences/userPreferences'

type Props = { onSuccess?: () => void } & SetAccountPreferencePropsUnion

export const useSetAccountPreferences = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ onSuccess: _onSuccess, ...props }: Props) => {
      return await setAccountPreference(props)
    },
    onSuccess: async (_, { onSuccess, ...props }: Props) => {
      const queryKey = getQueryKey('preferences/$path', {
        path: resolveKey(props),
      })
      await queryClient.invalidateQueries({ queryKey })
      onSuccess?.()
    },
    onError: (error) => {
      console.error('Error updating user account preferences', error)
    },
  })
}
